import React, { useState } from "react";

import companyIcon from "../assets/company_icon.png";

const RelatedJobs = (props) => {
	return (
		<li>
			<a rel="nofollow" target="_blank" href={props.job.url}></a>
				<div className="jobWrapper"><img src={props.job.logo !== "" ? props.job.logo : companyIcon} alt="Logo" />
					<h5 className="jobTitle">{props.job.jobtitle}</h5>
					<h6 className="jobLocation">{props.job.company} - {props.job.city}, {props.job.state} {props.job.zip}</h6>
					<h6 className="jobPostDate">{props.job.publishTime}</h6>
				</div>
		</li>
	)
}

export default RelatedJobs;
